import React, { Component } from 'react';
import { Waybill } from 'components/waybill/waybill';
import { Spin } from 'grab-ui';
import uuidv1 from 'uuid/v1';
import { ordersToWaybillData } from 'helper/waybill-helpers';
import _chunk from 'lodash/chunk';
import _get from 'lodash/get';
import {
  WAYBILLS_ORDERS_KEY,
  WAYBILLS_PAGE_READY,
} from 'constants/app-constants';
import css from './waybills.less';

class Waybills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      waybillsData: null,
      parentClosed: !window.opener,
    };
  }

  componentDidMount() {
    window.addEventListener('message', this.waybillsDataListener);
    // eslint-disable-next-line no-unused-expressions
    window.opener && window.opener.postMessage({ [WAYBILLS_PAGE_READY]: true });
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.waybillsDataListener);
  }

  waybillsDataListener = event => {
    if (event.origin !== window.location.origin) return;

    const orders = _get(event, `data.${WAYBILLS_ORDERS_KEY}`);
    if (orders) {
      this.setState({
        waybillsData: ordersToWaybillData(orders),
      });
    }
  };

  render() {
    const { waybillsData, parentClosed } = this.state;
    if (parentClosed) {
      return (
        <div className={css.errorContainer}>
          <p>Please generate waybills again.</p>
        </div>
      );
    }
    if (!waybillsData) {
      return (
        <div className={css.loadingContainer}>
          <Spin tip="Loading" />
        </div>
      );
    }
    return (
      <div className={css.rootContainer}>
        {_chunk(waybillsData, 4).map(waybillPage => (
          <div key={uuidv1()} className={css.page}>
            {waybillPage.map(data => (
              <Waybill
                key={uuidv1()}
                order={data.order}
                dropoffStepIndex={data.dropoffStepIndex}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }
}

export default Waybills;
